// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-dropdown-menu {
  border-radius: 0 0 20px 20px !important;
  overflow: hidden;
  padding: 1px 0 !important;
}

.ant-dropdown-menu-item-divider {
  margin: 0 !important;
}

.dropdown-container {
  margin: auto 0;
}
.dropdown-container .ant-dropdown-menu-item-divider {
  margin: 0 !important;
}

.dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffbd00 !important;
  padding: 4px;
  margin-top: 5px;
  cursor: pointer;
}
.dropdown-button .dropdown-greeting {
  margin-right: 5px;
  font-weight: bold;
}
.dropdown-button .dropdown-img {
  display: flex;
  border-radius: 50px;
  height: 44px;
  width: 44px;
  padding: 2px;
  box-sizing: border-box;
}
.dropdown-button .dropdown-img img {
  height: 100%;
  width: 100%;
  border-radius: 50% !important;
  border: 2px solid #ffbd00 !important;
}
.dropdown-button .dropdown-img .thumbanail-loading {
  height: 100% !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
}
.dropdown-button .dropdown-img .thumbanail-loading .ant-spin-spinning {
  line-height: 0 !important;
}
.dropdown-button i {
  font-weight: bolder !important;
  font-size: 18px !important;
}
.dropdown-button svg {
  color: #fff !important;
}

.dropdown-button:hover {
  color: #ffbd00 !important;
}
.dropdown-button:hover .dropdown-img img {
  border-color: #ffbd00 !important;
}

.menu-info {
  cursor: default;
}

.menu-info:hover {
  background-color: #fff !important;
}

.name {
  font-weight: bolder;
  padding-bottom: 0;
}

.email {
  padding-top: 0;
}

.menu-item:hover {
  background-color: #ffbd00 !important;
}

.submenu-item .ant-dropdown-menu-title-content {
  font-weight: bold;
}

.logout-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
}

.valid {
  color: #3cba54;
}

.alert {
  color: #db3236;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Dropdown/dropdown.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,gBAAA;EACA,yBAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,cAAA;AADF;AAEE;EACE,oBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AADF;AAEE;EACE,iBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAAJ;AACI;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,oCAAA;AACN;AACI;EACE,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AACN;AAAM;EACE,yBAAA;AAER;AAEE;EACE,8BAAA;EACA,0BAAA;AAAJ;AAGE;EACE,sBAAA;AADJ;;AAKA;EACE,yBAAA;AAFF;AAII;EACE,gCAAA;AAFN;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,iCAAA;AAJF;;AAOA;EACE,mBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,oCAAA;AAJF;;AAQE;EACE,iBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AANF;;AASA;EACE,cC9Ga;ADwGf;;AASA;EACE,cCjHe;AD2GjB","sourcesContent":["@import '../../../styles/colors.scss';\n\n.ant-dropdown-menu {\n  border-radius: 0 0 20px 20px !important;\n  overflow: hidden;\n  padding: 1px 0 !important;\n}\n\n.ant-dropdown-menu-item-divider {\n  margin: 0 !important;\n}\n\n.dropdown-container {\n  margin: auto 0;\n  .ant-dropdown-menu-item-divider {\n    margin: 0 !important;\n  }\n}\n\n.dropdown-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #ffbd00 !important;\n  padding: 4px;\n  margin-top: 5px;\n  cursor: pointer;\n  .dropdown-greeting {\n    margin-right: 5px;\n    font-weight: bold;\n  }\n  .dropdown-img {\n    display: flex;\n    border-radius: 50px;\n    height: 44px;\n    width: 44px;\n    padding: 2px;\n    box-sizing: border-box;\n    img {\n      height: 100%;\n      width: 100%;\n      border-radius: 50% !important;\n      border: 2px solid #ffbd00 !important;\n    }\n    .thumbanail-loading {\n      height: 100% !important;\n      width: 100% !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50% !important;\n      .ant-spin-spinning {\n        line-height: 0 !important;\n      }\n    }\n  }\n  i {\n    font-weight: bolder !important;\n    font-size: 18px !important;\n  }\n\n  svg {\n    color: #fff !important;\n  }\n}\n\n.dropdown-button:hover {\n  color: #ffbd00 !important;\n  .dropdown-img {\n    img {\n      border-color: #ffbd00 !important;\n    }\n  }\n}\n\n.menu-info {\n  cursor: default;\n}\n\n.menu-info:hover {\n  background-color: #fff !important;\n}\n\n.name {\n  font-weight: bolder;\n  padding-bottom: 0;\n}\n\n.email {\n  padding-top: 0;\n}\n\n.menu-item:hover {\n  background-color: #ffbd00 !important;\n}\n\n.submenu-item {\n  .ant-dropdown-menu-title-content {\n    font-weight: bold;\n  }\n}\n\n.logout-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 100;\n}\n\n.valid {\n  color: $status-valid;\n}\n\n.alert {\n  color: $status-invalid;\n}\n","$text-color: #464a4e;\n$title-color: #4a4f5d;\n$primary-color: #00a84a;\n$secondary-color: #50b570;\n$tertiary-color: #10a574;\n$quaternary-color: #00a84a;\n$hover-primary: #008241;\n$status-valid: #3cba54;\n$status-invalid: #db3236;\n$status-pending: #f4c20d;\n$status-doubt: #722ed1;\n$active-button: #4295ff;\n$inactive-button: #b7b7b7;\n$background-color: #f1f3f4;\n$black: #000000;\n$white: #ffffff;\n$printerTable-color: #00f26b1a;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
